import Vue from 'vue'
import ElementUI from 'element-ui'
import axios from 'axios'
import vue_cookie from 'vue-cookie'
import 'element-theme-default';
import './assets/css/font-awesome.css'
import "./assets/css/main.css"
import 'animate.css/animate.min.css'
import App from './App'
import Ad from './components/_common/Ad'
import ArticleList from './components/_common/ArticleList'
import router from './router'

Vue.use(ElementUI)
Vue.use(vue_cookie)
Vue.prototype.$config = {interfacebase:{'etfposition':'http://'+window.location.hostname+':3032','marketinfo':'http://'+window.location.hostname+':3022','calendar':'https://rili-d.jin10.com/open.php'},apibase: window.location.protocol+'//'+window.location.hostname}

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.component('Ad',Ad)
Vue.component('ArticleList',ArticleList)
Vue.filter('amount', function (value) {
  if(typeof(value) !== 'number'){
    value = Number(value);
  }
  return value.toFixed(2)
});
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js